import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/atoms/tooltip';
import { cn } from '@/lib/utils';

/** Toggle chip for an address role (Service / Billing / Primary). */
export function AddressRoleChip({
  label,
  active,
  disabled,
  onClick,
  tooltip,
}: {
  label: string;
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
  /** Hover/focus explanation of what the role means (or why it's disabled). */
  tooltip?: string;
}) {
  const chip = (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'rounded-full border px-3 py-1 text-xs font-medium transition-colors',
        active
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-border text-muted-foreground hover:bg-muted/60',
        disabled && 'cursor-not-allowed opacity-50 hover:bg-transparent',
      )}
    >
      {label}
    </button>
  );

  if (!tooltip) return chip;

  return (
    <Tooltip>
      {/* Wrap in a span so the tooltip still fires when the button is disabled. */}
      <TooltipTrigger asChild>
        <span className="inline-flex">{chip}</span>
      </TooltipTrigger>
      <TooltipContent side="top">{tooltip}</TooltipContent>
    </Tooltip>
  );
}
